import React, { useState } from 'react';
import { Calendar, MapPin, Plane, Hotel, Car, MoreVertical, Clock, CheckCircle, XCircle, XIcon, DownloadIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useAppContext } from '../context/AppContext';
export function TripsPage() {
  const {
    confirmedTrips
  } = useAppContext();
  const [toastMessage, setToastMessage] = useState<string | null>(null);
  const showToast = (message: string) => {
    setToastMessage(message);
    setTimeout(() => setToastMessage(null), 3000);
  };
  const upcomingTrips = [...confirmedTrips.map(trip => ({
    id: trip.id,
    title: trip.title,
    location: trip.location,
    dates: trip.dates,
    status: 'Confirmed',
    statusColor: 'bg-emerald-100 text-emerald-800',
    icon: CheckCircle,
    isNew: true
  })), {
    id: 101,
    title: 'Client Workshop',
    location: 'Chicago, IL',
    dates: 'Nov 18-20',
    status: 'Confirmed',
    statusColor: 'bg-emerald-100 text-emerald-800',
    icon: CheckCircle
  }, {
    id: 102,
    title: 'Tech Conference',
    location: 'Las Vegas, NV',
    dates: 'Dec 02-05',
    status: 'Pending Approval',
    statusColor: 'bg-amber-100 text-amber-800',
    icon: Clock
  }];
  const pastTrips = [{
    id: 4,
    title: 'Q3 Review',
    location: 'New York, NY',
    dates: 'Oct 10-12',
    status: 'Completed',
    statusColor: 'bg-slate-100 text-slate-600'
  }, {
    id: 5,
    title: 'Partner Summit',
    location: 'London, UK',
    dates: 'Sep 24-28',
    status: 'Completed',
    statusColor: 'bg-slate-100 text-slate-600'
  }, {
    id: 6,
    title: 'Sales Kickoff',
    location: 'Miami, FL',
    dates: 'Aug 15-18',
    status: 'Cancelled',
    statusColor: 'bg-red-100 text-red-800'
  }];
  return <div className="space-y-6" data-id="element-3288">
      {/* Toast */}
      {toastMessage && <div className="fixed top-20 right-6 z-50 animate-in slide-in-from-top-2" data-id="element-3289">
          <div className="bg-emerald-50 border border-emerald-200 text-emerald-800 rounded-lg p-4 shadow-lg flex items-center gap-3" data-id="element-3290">
            <CheckCircle className="h-5 w-5 text-emerald-600 flex-shrink-0" data-id="element-3291" />
            <p className="font-medium text-sm" data-id="element-3292">{toastMessage}</p>
            <button onClick={() => setToastMessage(null)} className="ml-2 text-emerald-500 hover:text-emerald-700" data-id="element-3293">
              <XIcon className="h-4 w-4" data-id="element-3294" />
            </button>
          </div>
        </div>}

      <div className="flex items-center justify-between" data-id="element-3295">
        <div data-id="element-3296">
          <h2 className="text-2xl font-bold text-slate-800" data-id="element-3297">My Trips</h2>
          <p className="text-slate-500" data-id="element-3298">
            Manage your upcoming and past itineraries.
          </p>
        </div>
        <Link to="/booking" className="rounded-lg bg-blue-600 px-4 py-2 text-sm font-medium text-white hover:bg-blue-700" data-id="element-3299">
          + Plan New Trip
        </Link>
      </div>

      {/* Active Trip Card */}
      <div className="rounded-xl border border-blue-200 bg-blue-50 p-6 shadow-sm" data-id="element-3300">
        <div className="flex items-center justify-between mb-4" data-id="element-3301">
          <span className="rounded-full bg-blue-600 px-3 py-1 text-xs font-medium text-white shadow-sm" data-id="element-3302">
            Current Trip
          </span>
          <button className="text-slate-400 hover:text-slate-600" data-id="element-3303">
            <MoreVertical className="h-5 w-5" data-id="element-3304" />
          </button>
        </div>
        <div className="flex flex-col md:flex-row md:items-center gap-6" data-id="element-3305">
          <div className="flex-1" data-id="element-3306">
            <h3 className="text-xl font-bold text-slate-900" data-id="element-3307">
              Q4 Strategy Meeting
            </h3>
            <div className="mt-2 flex items-center text-slate-600" data-id="element-3308">
              <MapPin className="mr-2 h-4 w-4" data-id="element-3309" />
              San Francisco, CA
            </div>
            <div className="mt-1 flex items-center text-slate-600" data-id="element-3310">
              <Calendar className="mr-2 h-4 w-4" data-id="element-3311" />
              Nov 12 - Nov 15, 2023
            </div>
          </div>
          <div className="flex gap-4" data-id="element-3312">
            <div className="rounded-lg bg-white p-4 shadow-sm text-center w-24 border border-blue-100" data-id="element-3313">
              <Plane className="mx-auto h-6 w-6 text-blue-600 mb-1" data-id="element-3314" />
              <span className="text-xs font-medium text-slate-600" data-id="element-3315">Flight</span>
            </div>
            <div className="rounded-lg bg-white p-4 shadow-sm text-center w-24 border border-blue-100" data-id="element-3316">
              <Hotel className="mx-auto h-6 w-6 text-blue-600 mb-1" data-id="element-3317" />
              <span className="text-xs font-medium text-slate-600" data-id="element-3318">Hotel</span>
            </div>
            <div className="rounded-lg bg-white p-4 shadow-sm text-center w-24 border border-blue-100" data-id="element-3319">
              <Car className="mx-auto h-6 w-6 text-blue-600 mb-1" data-id="element-3320" />
              <span className="text-xs font-medium text-slate-600" data-id="element-3321">Car</span>
            </div>
          </div>
        </div>
      </div>

      <h3 className="font-semibold text-slate-800 pt-4" data-id="element-3322">Upcoming Trips</h3>
      <div className="space-y-4" data-id="element-3323">
        {upcomingTrips.map(trip => <div key={trip.id} className="rounded-xl border border-slate-200 bg-white p-6 shadow-sm hover:border-blue-300 transition-colors" data-id="element-3324">
            <div className="flex items-start justify-between" data-id="element-3325">
              <div data-id="element-3326">
                <div className="flex items-center gap-2" data-id="element-3327">
                  <h4 className="text-lg font-semibold text-slate-900" data-id="element-3328">
                    {trip.title}
                  </h4>
                  {trip.isNew && <span className="bg-blue-100 text-blue-700 text-xs font-bold px-2 py-0.5 rounded-full" data-id="element-3329">
                      NEW
                    </span>}
                </div>
                <div className="flex items-center gap-4 mt-1" data-id="element-3330">
                  <p className="text-slate-500 text-sm flex items-center" data-id="element-3331">
                    <MapPin className="h-3 w-3 mr-1" data-id="element-3332" /> {trip.location}
                  </p>
                  <p className="text-slate-500 text-sm flex items-center" data-id="element-3333">
                    <Calendar className="h-3 w-3 mr-1" data-id="element-3334" /> {trip.dates}
                  </p>
                </div>
              </div>
              <span className={`rounded-full px-2.5 py-0.5 text-xs font-medium flex items-center gap-1 ${trip.statusColor}`} data-id="element-3335">
                {trip.icon && <trip.icon className="h-3 w-3" data-id="element-3336" />}
                {trip.status}
              </span>
            </div>
            <div className="mt-4 flex gap-2 pt-4 border-t border-slate-100" data-id="element-3337">
              <Link to={`/trips/${trip.id}`} className="text-sm font-medium text-blue-600 hover:underline" data-id="element-3338">
                View Itinerary
              </Link>
              <span className="text-slate-300" data-id="element-3339">|</span>
              <button onClick={() => showToast('Tickets downloaded successfully')} className="text-sm font-medium text-slate-500 hover:text-slate-700 flex items-center gap-1" data-id="element-3340">
                <DownloadIcon className="h-3 w-3" data-id="element-3341" />
                Download Tickets
              </button>
            </div>
          </div>)}
      </div>

      <h3 className="font-semibold text-slate-800 pt-4" data-id="element-3342">Past Trips</h3>
      <div className="space-y-4" data-id="element-3343">
        {pastTrips.map(trip => <div key={trip.id} className="rounded-xl border border-slate-200 bg-slate-50 p-4 opacity-75 hover:opacity-100 transition-opacity" data-id="element-3344">
            <div className="flex items-center justify-between" data-id="element-3345">
              <div data-id="element-3346">
                <h4 className="font-medium text-slate-700" data-id="element-3347">{trip.title}</h4>
                <p className="text-slate-500 text-xs mt-1" data-id="element-3348">
                  {trip.location} • {trip.dates}
                </p>
              </div>
              <span className={`rounded-full px-2.5 py-0.5 text-xs font-medium ${trip.statusColor}`} data-id="element-3349">
                {trip.status}
              </span>
            </div>
          </div>)}
      </div>
    </div>;
}